import { render, staticRenderFns } from "./BtnAprovar.vue?vue&type=template&id=3fdb4694"
import script from "./BtnAprovar.vue?vue&type=script&lang=js"
export * from "./BtnAprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports